export const WORKFLOW_EXPIRY_AFTER_DAYS = 90;
export const WORKFLOW_EXPIRY_WARNING_AFTER_DAYS = 0;
export const SECONDS_IN_A_DAY = 86400000;
